// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyBA3O2eJug-nNV4n-1tmgkAduxw7XtjgUA",
  authDomain: "ghana-67644.firebaseapp.com",
  projectId: "ghana-67644",
  // use the exact bucket name visible via gsutil
  storageBucket: "ghana-67644.firebasestorage.app",
  messagingSenderId: "290403779751",
  appId: "1:290403779751:web:7acf15cde278efacdec782",
  measurementId: "G-VYD8S1T5SF"
};

const app = initializeApp(firebaseConfig)

// ✅ App secondaire pour que l'admin puisse créer des comptes
let secondaryApp = null;
let secondaryAuth = null;

export const getSecondaryAuth = () => {
  if (!secondaryApp) {
    secondaryApp = initializeApp(firebaseConfig, "Secondary");
    secondaryAuth = getAuth(secondaryApp);
  }
  return secondaryAuth;
};

export const db = getFirestore(app)
export const functions = getFunctions(app, "europe-west1")
export const auth = getAuth(app)
export const storage = getStorage(app)
